






































































































































































/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import FeatureInfoUtils from '@/models/map-context/FeatureInfoUtils';
import Filter from '@/models/map-context/filter/Filter';
import LayerAttribute from '@/models/map-context/LayerAttribute';
import LayerConfig from '@/models/map-context/LayerConfig';
import { PluginLocation } from '@/models/plugin/PluginLocation';
import EditionService from '@/services/EditionService';
import {  EVENTS } from '@/services/EventBus';
import { MapService } from '@/services/MapService';
import sanitizeHtml from 'sanitize-html';
import Component from 'vue-class-component';
import PluginComponent from '../plugins/PluginComponent';
import CesiumFeatureInfosPanel from './CesiumFeatureInfosPanel.vue';
import { transform } from 'ol/proj';

declare let Cesium: any;

@Component<FeatureInfosPanel>({
  props: {
    movablePanel:{ default: false },
  },
  components: {
    CesiumFeatureInfosPanel,
  },
})
export default class FeatureInfosPanel extends PluginComponent {
  static ID='feature-infos';

  static NAME='FeatureInfosPanel';

  static MOVABLE='movable';

  static MOVABLE_SWITCH='movableSwitch';

  // !!les 2 propriétés suivantes peuvent contenir des objects Cesium, il ne faut pas que ces propriétés soient reactives, 
  // cela rentre en conflit avec le fonctionnement de cesium et cause de gros pb de performances
  private currentFeature:any;

  private allFeatures:any;

  public keys = Array<any>();

  public showChilds = true;

  isCesiumFeature = false;

  movablePanel!:Boolean;

  isFeatureSelected = false;

  public keysForEdition = Array<any>();

  public layerOfFeature: LayerConfig|null=null;

  edition = false;

  showList=false;

  editionService!:EditionService;

  featureIndex = 0;

  selectedDate= null;

  datepickerVisibility= {} as Record<string, boolean>;

  customTemplate:any='';

  customHtmltemplate = false;

  showNearFeatures = false;

  infosContent = '';

  config:any;

  movable = false;

  movableSwitch = false;

  isDragging = false;

  modalLeft = 0;

  modalTop = 120;

  offsetX = 0;

  offsetY = 0;

  width = 0;

  coordinateX='';
  coordinateY='';
  dataProjection:any=null;

  mapId= 'mapcontainer';

  toggleCalendar(propName: string) {
    if (this.datepickerVisibility[propName] === undefined) {
      this.$set(this.datepickerVisibility, propName, false);
    }

    this.datepickerVisibility[propName] = !this.datepickerVisibility[propName];

    if (this.datepickerVisibility[propName]) {
      this.$nextTick(() => {
        document.addEventListener('click', (event) => this.handleOutsideClick(event, propName));
      });
    } else {
      document.removeEventListener('click', (event) => this.handleOutsideClick(event, propName));
    }
  }



  getTodayDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getCustomStyle(movable:boolean, width: number) {
    let r;
    if (movable) {
      r = `left:${this.modalLeft}px;top:${this.modalTop}px`;
    } else {
      r = 'height:100%';
    }
    if (width > 0 && !this.contextService.isMobile()) {
      r += `;width:calc(${width}vw - 50px);`
    }
    return r;
  }
  getDatavizStyle() {
    let s='';
    let layerConfig:LayerConfig=this.currentFeature.layerConfig;
    let height=layerConfig.dataviz.height;
    if (height > 0) {
      s += `height:${height}vh;`
    }
    return s;
  }
  onSelectedDateChange(prop: any) {
    if (!prop.value) {
      prop.value =  this.getTodayDate()
    } else {
      this.$nextTick(() => {
        prop.value = prop.value;
      });
    }
  }

  validateDate(propName: string){
    this.datepickerVisibility[propName] = false;
  }

  handleOutsideClick(event: MouseEvent, propName: string) {
    const datepicker = this.$refs[`datepickerRef${propName}`] as any;
    const toggleButton = this.$refs[`toggleButton${propName}`] as any;
    const inputRef = this.$refs[`inputRef${propName}`] as any;

    console.log("Debug Info:", datepicker, toggleButton, inputRef);

    if (
      datepicker && !datepicker[0].$el.contains(event.target as Node) &&
      toggleButton && !toggleButton[0].contains(event.target as Node) &&
      inputRef&& !inputRef[0].$el.contains(event.target as Node)
    ) {
      this.$set(this.datepickerVisibility, propName, false);
      document.removeEventListener('click', (event) => this.handleOutsideClick(event, propName));
    }
  }

  initDrag(): void {
    const mainMap = document.getElementById(this.mapId);
      if (!mainMap) return;
    
    const mainMapRect = mainMap.getBoundingClientRect();
    this.modalLeft = mainMapRect.left + mainMapRect.width - this.$el.clientWidth - 32;
    const pos=this.contextService.getPosition('featureInfoPanel');
    if(pos && pos[0]<=this.modalLeft){
        this.modalLeft=pos[0];
        this.modalTop=pos[1];
    }

  }

  private getEventClientPosition(event: MouseEvent | TouchEvent): { clientX: number; clientY: number } {
    if ('touches' in event && event.touches.length > 0) {
      return { clientX: event.touches[0].clientX, clientY: event.touches[0].clientY };
    }
    if ('changedTouches' in event && event.changedTouches.length > 0) {
      return { clientX: event.changedTouches[0].clientX, clientY: event.changedTouches[0].clientY };
    }
    return { clientX: (event as MouseEvent).clientX, clientY: (event as MouseEvent).clientY };
  }

  startDragging(event: MouseEvent | TouchEvent) {
    if (this.movable) {
      const { clientX, clientY } = this.getEventClientPosition(event);
      const rect = this.$el.getBoundingClientRect();
      this.offsetX = clientX - rect.left;
      this.offsetY = clientY - rect.top;
      this.isDragging = true;
    }
  }

 stopDragging() {
    this.isDragging = false;
    this.storePosition();
  }
  storePosition(){
    this.contextService.storePosition('featureInfoPanel',[this.modalLeft,this.modalTop]);
  }

  dragModal(event: MouseEvent | TouchEvent) {
    if (!this.isDragging) {
      return;
    }
    if ('touches' in event) {
      event.preventDefault();
    }
    const { clientX, clientY } = this.getEventClientPosition(event);
    const mainMap = document.getElementById(this.mapId);
    if (!mainMap) return;

    const mainMapRect = mainMap.getBoundingClientRect();

    const newLeft = Math.min(
      Math.max(mainMapRect.left, clientX - this.offsetX),
      mainMapRect.right - this.$el.clientWidth
    );
    const newTop = Math.min(
      Math.max(mainMapRect.top, clientY - this.offsetY),
      mainMapRect.bottom - this.$el.clientHeight
    );

    this.modalLeft = newLeft - mainMapRect.left;
    this.modalTop = newTop - mainMapRect.top;
  }

  beforeDestroy():void {
    this.getEventBus().$off(EVENTS.PLUGIN_ACTIVATION_CHANGE, this.onUpdateActive);
    this.getEventBus().$off(EVENTS.SELECT_FEATURE, this.onFeatureSelected);

    if(this.movablePanel){
      document.removeEventListener('mousemove', this.dragModal);
      document.removeEventListener('mouseup', this.stopDragging);
      document.removeEventListener('touchmove', this.dragModal);
      document.removeEventListener('touchend', this.stopDragging);
      document.removeEventListener('touchcancel', this.stopDragging);
    }

  }

  created() {
    this.loadPlugins();
    this.getEventBus().$on(EVENTS.PLUGIN_ACTIVATION_CHANGE, this.onUpdateActive);

    this.onUpdateActive();
    const mapService = this.getMapService();
    this.config = mapService.config;
    if (mapService instanceof MapService) {
      this.editionService = mapService.editionService;
    }
  }

  mounted() {
    this.allFeatures=[];
    this.getEventBus().$on(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    this.getEventBus().$on(EVENTS.SELECT_NO_FEATURE, this.cleanSelection);
    
    if(this.movablePanel){
      document.addEventListener('mousemove', this.dragModal);
      document.addEventListener('mouseup', this.stopDragging);
      document.addEventListener('touchmove', this.dragModal, { passive: false });
      document.addEventListener('touchend', this.stopDragging);
      document.addEventListener('touchcancel', this.stopDragging);
    }

    const selectedFeatures = this.getMapService().selectionService.selectedFeature;
    if (selectedFeatures !== undefined) {
      this.onFeatureSelected(selectedFeatures);
    }
    
  }

  cleanSelection(){
    this.allFeatures=[];
    this.currentFeature=null;
    this.isFeatureSelected=false;
    this.closePanel();
  }

  onUpdateActive() {
    this.movable = this.pluginService.getBooleanParameter(FeatureInfosPanel.NAME, FeatureInfosPanel.MOVABLE);
    this.movableSwitch = this.pluginService.getBooleanParameter(FeatureInfosPanel.NAME, FeatureInfosPanel.MOVABLE_SWITCH);
    this.updateIcon();
  }

  updateIcon() {
    const plugin = this.pluginService.getByName(FeatureInfosPanel.NAME);
    // to remove the icon
    if (plugin) {
      if (this.movable) {
        plugin.configuration.position = PluginLocation.Modal;
      } else {
        plugin.configuration.position = PluginLocation.LeftToolBar;
      }
    }
    if (!this.movable) {
      this.getEventBus().$emit(EVENTS.OPEN_LEFT_SIDE_MENU, FeatureInfosPanel.NAME);
    }
  }

  toggleMovable() {
    this.movable = !this.movable;
    this.pluginService.setBooleanParameter(FeatureInfosPanel.NAME, FeatureInfosPanel.MOVABLE, this.movable);
    this.updateIcon();
    if (this.movable) {
      this.closePanel();
      this.getEventBus().$emit(EVENTS.OPEN_LEFT_SIDE_MENU, '');
    }
  }

  closePanel() {
    this.currentFeature = null;
    this.isFeatureSelected = false;
    this.getMapService().selectionService.resetClickToggleState();
    if(!this.movable){
      this.getEventBus().$emit(EVENTS.OPEN_LEFT_SIDE_MENU, '');
    }
    
  }

  toggleList() {
    this.showList = !this.showList;
  }
  
  getNbFeatures() {
    return this.allFeatures.length;
  }

  onFeatureSelected(features:any) {
    //remove features where ficheInfos is disabled
    features=features.filter((f:any)=>f.layerConfig.ficheInfos.enabled==true);
    if(this.movablePanel){
      
      this.initDrag();
      
    }
    this.featureIndex = 0;
    console.log('onFeatureSelected');
    this.currentFeature = features[this.featureIndex];
    this.customTemplate='';
    // find plugin for custom featureInfos
    this.pluginComponents.forEach((compo:any) => {
      if(compo.default.extendOptions==undefined){
        console.error(compo)
      }
      if(compo.default.extendOptions.methods && compo.default.extendOptions.methods.openOnSelectedFeature && compo.default.extendOptions.methods.openOnSelectedFeature(features)){
        if(this.pluginService.getByName(compo.default.ID)?.isActive){
          this.customTemplate=compo.default.ID;
        }
      }
    });

    this.isFeatureSelected = this.currentFeature!=null;
    if (this.currentFeature.id && this.currentFeature.id instanceof Cesium.Entity && this.currentFeature.id.layerConfig.is3DModel()) { // Cesium feature ? => show Cesium Panel
      this.isCesiumFeature = true;
      return;
    }
    if (this.currentFeature.id && this.currentFeature.id instanceof Cesium.Entity) { // Cesium feature ? => show Cesium Panel
      this.currentFeature = this.currentFeature.id;
    }
    this.allFeatures = features;

    this.parseFeature();
    this.calculateCoords();
  }

  resetCoords() {
    this.dataProjection = null;
    this.coordinateX = '';
    this.coordinateY = '';
  }

  calculateCoords() {
    try {
      const coordinates =  this.currentFeature?.getGeometry()?.getCoordinates();
      if (coordinates) {
        const layer = this.currentFeature.layerConfig;
        if (layer.dataProjection && layer.dataProjection.length > 0) {
          this.dataProjection = layer.dataProjection;
        } else {
          this.dataProjection = 'EPSG:2154';
        }
        const coords = transform(coordinates, 'EPSG:3857', this.dataProjection);
        this.coordinateX = coords[0].toFixed(2);
        this.coordinateY = coords[1].toFixed(2);;
      } else {
        this.resetCoords();
      }
    } catch(err) {
       // Impossible de récupérer les coordonnées
      this.resetCoords();
    }
  }

  hasDataviz() {
    if (this.currentFeature) {
      return this.currentFeature.layerConfig.dataviz.active;
    }
    return false;
  }

  getDatavizUrl() {
    if (this.currentFeature) {
      return this.currentFeature.layerConfig.dataviz.getUrl(this.currentFeature);
    }
    return false;
  }

  parseFeature() {
    if (this.currentFeature) {
      this.edition = false;
      if (this.currentFeature) {
        this.layerOfFeature = this.currentFeature.layerConfig;
        if (this.layerOfFeature && this.layerOfFeature.editing) {
          this.edition = true;
        }
        if (this.layerOfFeature && this.layerOfFeature.ficheInfos.width && this.layerOfFeature.ficheInfos.width>=20 && this.layerOfFeature.ficheInfos.width<=100) {
          this.width = this.layerOfFeature.ficheInfos.width;
        } else {
          this.width = 0;
        }
        this.customHtmltemplate = false;
        this.infosContent ='';
        this.showNearFeatures=true;
        
        if (this.layerOfFeature && this.layerOfFeature.ficheInfos.active) {
          this.showNearFeatures=false;
          if(this.layerOfFeature.ficheInfos.showNearFeatureList){
            this.showNearFeatures=true;
          }
          this.customHtmltemplate = true;
          const regEx = new RegExp(/{(.*?)}/, 'ig');
          let feature=this.currentFeature;
          let infosContent =(<string>this.layerOfFeature.ficheInfos.content).replace(regEx, (a:any, b:any) => {
            let value = feature ? Filter.evaluateExpression(b, feature.getProperties()) : null;
            
            //if value is a number with lots of decimals, truncate to 3 redmine #21755
            if(!isNaN(parseFloat(value)) && isFinite(value)){
              value=parseFloat(value);
              if( (value+"").indexOf('.')>0){
                let nbDecimale = (value+"").split(".")[1].length;
                if(nbDecimale>5){
                  value=Math.round(value*1000)/1000;
                }
              }
             
            }

            return value != undefined ? value : '';
          });
          infosContent = sanitizeHtml(infosContent,{
            allowedTags: sanitizeHtml.defaults.allowedTags.concat([ 'img' ]),
            allowedAttributes: {
              a: [ 'href', 'name', 'target' ],
              td: [ 'colspan', 'rowspan', 'style','class'],
              table: [  'style','class'],
              figure: [  'style','class'],
              p: [  'style','class'],
              span: [  'style','class'],
              // We don't currently allow img itself by default, but
              // these attributes would make sense if we did.
              img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading','style','class' ]
            },
            allowedSchemesByTag: {
              img: [ 'data','https' ]
            }
          });
          this.infosContent = infosContent;// "<div class='ck-content'>"+popupinfosContent+'</div>';
        }
      }

      this.keys = Array<any>();

      console.log(this.layerOfFeature);
      const self = this;
      if (this.layerOfFeature && this.layerOfFeature.layerProperties
          && this.layerOfFeature.layerProperties.length > 0) {
        const layerProperties = this.layerOfFeature.layerProperties;
        this.keysForEdition = layerProperties.filter((x:LayerAttribute): any => x.name !== this.currentFeature.geometryName_ && x.editable);
        this.keysForEdition.forEach((key:any) => {
          key.value = FeatureInfoUtils.getFeatureValue(this.currentFeature, key.name);
        });
        this.keys = FeatureInfoUtils.getDisplayKeys(this.currentFeature, layerProperties, 'display');
      } else {
        this.keys = FeatureInfoUtils.getDisplayKeys(this.currentFeature, [], 'display');
      }

      const target:any = this.$refs.customContent;
      if (this.layerOfFeature && (<any>this.layerOfFeature).featureInfoContentRenderer) {
        // eslint-disable-next-line no-unused-expressions
        this.layerOfFeature!.featureInfoContentRenderer(self.currentFeature, target);
      }
    } else {
      // reset le panneau de moficiation
      this.currentFeature = null;
      this.layerOfFeature = null;
      this.isFeatureSelected = false;
    }
  }

  modulo(n:number, m:number):number {
    return ((n % m) + m) % m;
  }

  previousFeature() {
    this.changeFeatureIndex(this.modulo((this.featureIndex - 1), this.allFeatures.length));
  }

  nextFeature() {
    this.changeFeatureIndex(this.modulo((this.featureIndex + 1), this.allFeatures.length));
  }

  changeFeatureIndex(featureIndex:number) {
    console.log('changeFeatureIndex '+featureIndex);
    this.featureIndex = featureIndex;
    this.currentFeature = this.allFeatures[this.featureIndex];
    this.getMapService().selectionService.cleanSelection();
    this.getMapService().selectionService.addToSelection(this.currentFeature);
    this.parseFeature();
  }

  getDisplayLabel(feature:any) : string {
    console.log(feature);
    // Pour afficher les valeurs des 4 premiers attributs
    const featureTxt = feature.getKeys().filter((x:any) => x !== 'geometry').slice(0, 4).map((x:any) => feature.get(x))
      .join();
    // return `${feature.layerConfig.title}`;
    return `${feature.layerConfig.title}-${featureTxt}`;
  }
  getDisplayLabelIndex(index:number) : string {
    const f =  this.allFeatures[index];
    // Pour afficher les valeurs des 4 premiers attributs
    const featureTxt = f.getKeys().filter((x:any) => x !== 'geometry').slice(0, 4).map((x:any) => f.get(x))
      .join();
    // return `${feature.layerConfig.title}`;
    return `${f.layerConfig.title}-${featureTxt}`;
  }

  isLink(key:any):boolean {
    return FeatureInfoUtils.isLink(this.getValue(key));
  }

  getValue(key:any) {
    return FeatureInfoUtils.getFeatureValue(this.currentFeature, key);
  }
  getLabelForEdition(key:any){
    let label=this.getLabel(key.name);
    if(key.isMandatory()){
      label+=" *"
    }
    return label;
  }

  getLabel(key:any) {
    if (this.layerOfFeature && this.layerOfFeature.layerProperties) {
      return FeatureInfoUtils.getAttributeLabel(this.layerOfFeature.layerProperties, key);
    }

    return key;
  }

  deleteObject(){
    this.editionService.deleteFeature(this.currentFeature, this.layerOfFeature!);
    this.closePanel();
  }
  save(): void {
    console.log('saving feature');
    const self = this;
    this.keysForEdition.forEach((key) => {
      if(key.isNumber() && key.value==""){
        console.warn(key.name+ ' vide donc ignoré')
      }else if(key.isBoolean() && key.value==""){
        self.currentFeature.set(key.name, false);
      }
      else{
        self.currentFeature.set(key.name, key.value);
      }
      
    });
    if (this.layerOfFeature!.isWFS()) {
      //if not ID insert
      if(this.currentFeature.getId()==undefined){
        this.editionService.updateFeature(this.currentFeature, this.layerOfFeature!, 'insert');
      }else{
         this.editionService.updateFeature(this.currentFeature, this.layerOfFeature!, 'update');
      }
     
    }

    this.edition = false;
    this.parseFeature();
  }

  cancel(): void {
    this.edition = false;
  }
}
